// On phones only the first cards show; the button opens the rest.
export default function initTeamCards(): void {
	document.querySelectorAll<HTMLElement>('[data-armada-team-cards]').forEach((block) => {
		const toggle = block.querySelector<HTMLButtonElement>('.armada-team-cards__toggle');
		const label = toggle?.querySelector<HTMLElement>('.armada-team-cards__toggle-label');

		if (!toggle || !label) {
			return;
		}

		toggle.addEventListener('click', () => {
			const open = toggle.getAttribute('aria-expanded') !== 'true';

			block.classList.toggle('is-expanded', open);
			toggle.setAttribute('aria-expanded', String(open));
			label.textContent = (open ? toggle.dataset.less : toggle.dataset.more) || label.textContent;

			// Closing from far below would leave the reader past the block.
			if (!open && block.getBoundingClientRect().top < 0) {
				block.scrollIntoView({ block: 'start' });
			}
		});
	});
}
